module.exports = __webpack_public_path__ + "img/89.e5a9cf8e.png";